import React from 'react';
import EditLeague from '../../components/leagues/edit-league';

const EditLeagueContainer = () => {
    return <EditLeague />;
};

export default EditLeagueContainer;
